export const FeatureProviderNameEnum = {
    INTERNAL_COWORKINGS: 'INTERNAL_COWORKINGS',
    INTERNAL_ANALYTICS: 'INTERNAL_ANALYTICS',
    INTERNAL_FLEX: 'INTERNAL_FLEX',
};
